// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatarEditor_wrapper{
    border-radius: 14px;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    max-width: 450px;
}

.avatarEditor_canvas_area{

}

.avatarEditor_canvas{
    display: block;
    width: 100%;
}

.avatarEditor_form{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 40px;
    height: 100%;
    background-color: #fffc;
}

.avatarEditor_scaleBlock{
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    font-size: 11px;
    font-weight: 700;
    padding-top: 5px;
    gap:5px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/addClient/AvatarEditorBlock.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;AAEA;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,OAAO;AACX","sourcesContent":[".avatarEditor_wrapper{\n    border-radius: 14px;\n    overflow: hidden;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 10px;\n    max-width: 450px;\n}\n\n.avatarEditor_canvas_area{\n\n}\n\n.avatarEditor_canvas{\n    display: block;\n    width: 100%;\n}\n\n.avatarEditor_form{\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 40px;\n    height: 100%;\n    background-color: #fffc;\n}\n\n.avatarEditor_scaleBlock{\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    align-items: center;\n    font-size: 11px;\n    font-weight: 700;\n    padding-top: 5px;\n    gap:5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
